import type { RouteObject } from 'react-router-dom';

export const BaseChildrenRoutes = [] satisfies RouteObject[];
